module.exports = __webpack_public_path__ + "static/media/ice-skate.f52f7230.svg";